import { createContext } from 'react';

interface IAppContextData {
  loading: boolean;
  handleChangeLoading(loading: boolean): void;
}

const initialState = {
  loading: false,
  handleChangeLoading: (loading: boolean) => loading,
};

export const AppContext = createContext<IAppContextData>(initialState);
